import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

interface PublicLayoutProps extends RouteComponentProps {
  children: React.ReactNode;
}
class PublicPagesLayout extends React.PureComponent<PublicLayoutProps> {
  render() {
    const { children } = this.props;
    return children;
  }
}

export const PublicLayout = withRouter(PublicPagesLayout);
